export default {
  formValidation: {
    emptyField: 'El campo no puede estar vacío',
    requiredField: 'El campo es obligatorio',
    passwordToShort: 'La contraseña debe tener 8 caracteres',
    emailNotValid: 'El campo debe contener una dirección de correo electrónico válida',
    emailReserved: 'La dirección de correo electrónico ya está ocupada',
    rateEmpty: 'Todos los campos deben estar completos',
    serverUnknownError: 'Error de comunicación con el servidor',
    invalidCharacters: 'El campo contiene caracteres no válidos',
    phoneNotValid: 'El número de teléfono es incorrecto',
    checkBoxBelow: 'Por favor, marque la casilla de abajo para enviar un mensaje',
  },
  password: {
    show: 'mostrar',
    hide: 'ocultar',
  },
  howItWorks: {
    showButton: 'Mostrar más',
    hideButton: 'Mostrar menos',
  },
}
